export default __webpack_public_path__ + "static/media/cardano_color2.3be22eb5.svg";